import { makeStyles, shorthands } from '@fluentui/react-components';

export const useBrowseButtonStyles = makeStyles({
  root: {
    ...shorthands.padding('2px', '8px'),
    ...shorthands.margin('2px'),
    minWidth: 'unset',

    '& .browse-label': {
      width: 'auto',
      maxWidth: '0',
      overflowX: 'hidden',
      ...shorthands.transition('all', '0.3s'),
    },

    '&:hover .browse-label': {
      maxWidth: '100px',
    },

    '& .fui-Button__icon': {
      ...shorthands.transition('margin-right', '0.3s'),
    },

    '&:not(:hover)  .fui-Button__icon': {
      marginRight: '0',
    },
  },
});
